import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * AdminOverviewPage � Redirects to the Admin Dashboard.
 */
export const AdminOverviewPage: React.FC = () => {
  return <Navigate to="/administracao/dashboard" replace />;
};
